import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { useAppContext } from 'Context/ReactAppContext';
import { isSeller } from 'Utils/seller/sellerUtils';
import { t } from 'Src/i18n';
import { Icon } from 'Components/frameworks/icon/Icon';
const MESSAGES = {
  CABIN: {
    SELLER: 'booking.accommodation.cabinArrangementMessageB2B',
    NOT_SELLER: 'booking.accommodation.cabinArrangementMessage',
  },
  DEFAULT: {
    SELLER: 'booking.accommodation.roomArrangementMessage',
    NOT_SELLER: 'booking.accommodation.roomArrangementMessage',
  },
};
const LABELS = {
  ADULT: 'booking.common.adult',
  BABY: 'booking.common.baby',
  CHILD: 'booking.common.child',
};
type Attendee = {
  id: string;
  index: number;
  firstName?: string;
  lastName?: string;
  type: string;
};
type Props = {
  className?: string;
  distribution:
    | {
        adults: Array<Attendee>;
        babies: Array<Attendee> | null | undefined;
        children: Array<Attendee> | null | undefined;
      }
    | null
    | undefined;
  isCabin?: boolean;
};
export const AccommodationRoomDistribution = ({ className, distribution, isCabin }: Props) => {
  const appContext = useAppContext();

  if (!distribution) {
    return null;
  }

  const NODE = isCabin ? MESSAGES.CABIN : MESSAGES.DEFAULT;
  const msg = isSeller(appContext) ? NODE.SELLER : NODE.NOT_SELLER;
  const { adults, babies, children } = distribution;
  return (
    <div className={className}>
      <ul className="-mx-5 mb-5 flex flex-wrap items-end">
        {[adults, babies, children].filter(Boolean).map((d) =>
          d.map(({ firstName, id, index, lastName, type = 'ADULT' }) => (
            <li className="p-5 text-14 text-sienna" key={id} data-testid={`test_${type}_${index}`}>
              <Icon
                className="me-5"
                name={ICONS.PEOPLE}
                width={type === 'ADULT' ? '1.3em' : '1em'}
              />
              {t(LABELS[type])} {index + 1}
              {isSeller(appContext) && firstName && lastName ? (
                <span className="ms-10 capitalize">
                  {`${firstName} ${lastName}`.toLocaleLowerCase()}
                </span>
              ) : null}
            </li>
          )),
        )}
      </ul>
      <p className="font-sans text-12 text-sienna">{t(msg)}</p>
    </div>
  );
};
